import React from 'react';
import QuotationsList from './QuotationsList';

const Quotations = () => {
  return <QuotationsList />;
};

export default Quotations;
